import { BannerForm, IBannerFormData } from '../components/BannerForm'
import { Box, Typography } from '@material-ui/core'
import React, { useCallback, useState } from 'react'
import { Spacer, useToasts } from '@vestaboard/installables'

import { ImageUpload } from '../components/ImageUpload'
import { useCreateHomeScreenBanner } from '../hooks/useCreateHomescreenBanner'
import { useHistory } from 'react-router'

export const CreateHomeScreenBanner = () => {
  const history = useHistory()
  const [createBanner] = useCreateHomeScreenBanner()
  const { addToast } = useToasts()
  const [saving, setSaving] = useState(false)
  const [createdBannerId, setCreatedBannerId] = useState<string | null>(null)

  const handleCreate = useCallback(async (data: IBannerFormData) => {
    setSaving(true)
    try {
      const result = await createBanner({
        variables: {
          input: {
            title: data.title,
            description: data.description,
            backgroundColor: data.backgroundColor,
            positionInFeed: data.positionInFeed,
            enabled: data.enabled || false,
            buttons: data.buttons.map(button => ({
              title: button.title,
              deepLinkUrl: button.deepLinkUrl
            }))
          }
        }
      })

      const createResult = result.data?.createHomeScreenBanner

      if (createResult?.__typename === 'HomeScreenBannerV2') {
        setCreatedBannerId(createResult.id)
        addToast('Banner created successfully', {
          autoDismiss: true,
          appearance: 'success'
        })
      } else {
        addToast(`Error: ${createResult?.error || 'Failed to create banner'}`, {
          autoDismiss: true,
          appearance: 'error'
        })
      }
    } catch (error) {
      addToast('Failed to create banner', {
        autoDismiss: true,
        appearance: 'error'
      })
    } finally {
      setSaving(false)
    }
  }, [createBanner, addToast])

  const handleCancel = useCallback(() => {
    history.push('/home-screen-banner')
  }, [history])

  const handleImageUploaded = useCallback(() => {
    // Refresh or show success message
    addToast('Banner image uploaded successfully', {
      autoDismiss: true,
      appearance: 'success'
    })
  }, [addToast])

  const handleFinish = useCallback(() => {
    history.push('/home-screen-banner')
  }, [history])

  if (createdBannerId) {
    return (
      <Box>
        <Typography variant='h4' gutterBottom>
          Upload Banner Image
        </Typography>
        <Typography variant='body1' color='textSecondary' gutterBottom>
          Your banner has been created successfully. You can now upload an image for it.
        </Typography>
        <Spacer size='large' />
        <ImageUpload
          bannerId={createdBannerId}
          onImageUploaded={handleImageUploaded}
        />
        <Spacer size='large' />
        <button
          onClick={handleFinish}
          style={{
            padding: '12px 24px',
            backgroundColor: '#3f51b5',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Finish
        </button>
      </Box>
    )
  }

  return (
    <Box>
      <Typography variant='h4' gutterBottom>
        Create New Banner
      </Typography>
      <Spacer size='large' />
      <BannerForm
        onSave={handleCreate}
        onCancel={handleCancel}
        loading={saving}
      />
    </Box>
  )
}